module.exports = __webpack_public_path__ + "images/maskable_icon-96.a161fbe1664a112237113823bb085512.png";